import React, { memo, useCallback } from 'react'
import * as Styled from './styled'
import { IFlyoutMenuItem } from '../types'
import Text from 'common-components/Text'

interface IMenuProps {
  actions: IFlyoutMenuItem[]
  className?: string
  onClose: () => void
  isMobileDrawerStyle?: boolean
}

const Menu: React.FC<IMenuProps> = props => {
  const { actions, className, onClose, isMobileDrawerStyle } = props

  const handleAction = useCallback(
    (action?: () => void) => {
      action?.()
      onClose()
    },
    [onClose]
  )

  return (
    <Styled.MenuList
      className={className}
      $isMobileDrawerStyle={isMobileDrawerStyle}
    >
      {actions.map(action => (
        <Styled.MenuItem
          key={action.key}
          onClick={() => handleAction(action.onClick)}
          $isMobileDrawerStyle={isMobileDrawerStyle}
          data-testid={action.testId}
        >
          {action?.component && action.component}
          {action?.icon && (
            <Styled.IconWrapper
              $width={action.iconSize?.width}
              $height={action.iconSize?.height}
            >
              {action.icon}
            </Styled.IconWrapper>
          )}
          {action?.title && (
            <Text type="h2" color="secondarySemiDark" lineHeight="20px">
              {action.title}
            </Text>
          )}
        </Styled.MenuItem>
      ))}
    </Styled.MenuList>
  )
}

export default memo(Menu)
